import { useState } from 'react';
import './ContactUs.css'
import send from '../../assets/svg/send.svg'
import location2 from '../../assets/svg/location2.svg'
import mail from '../../assets/svg/mail.svg'
import { useDialog } from '../DialogProvider/DialogProvider';
import { contactUs } from '../../services/httpService';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export const contactUsSchema = yup.object({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    email: yup
        .string()
        .email('Invalid email address')
        .required('Email is required'),
    organization: yup.string().required('Organization is required'),
    message: yup
        .string()
        .required('Message is required')
        .max(1000, 'Maximum 1000 characters'),
});
function ContactUs({ show }) {
    const { openDialog, closeDialog, animation } = useDialog();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(contactUsSchema),
    });

    const onSubmit = async (data) => {
        const payload = {
            fullname: `${data.firstName} ${data.lastName}`,
            email: data.email,
            organization: data.organization,
            message: data.message,
        };

        try {
            await contactUs(payload, reset, openDialog);
            // closeDialog();
        } catch (error) {
            console.error('Error submitting contact form:', error);
        }
    };

    if (!show) return null;

    return (
        <div className='popup-wrapper'>
            <div
                className='ContactUs popup-body animation'
                style={{ animationName: animation }}
            >
                <div className='ContactUs-left'>
                    <div className='bold-heading'>We’d love to hear from you.</div>

                    <div className='gap-24 d-lg-flex d-none'>
                        <img src={mail} alt='mail' />
                        <div className='theme-bold-text-24'>info@brainyclock.com</div>
                    </div>

                    <div className='align-items-start gap-24 d-lg-flex d-none'>
                        <img src={location2} alt='location' className='mt-2' />
                        <div className='theme-bold-text-24'>
                            251 East 32nd Street <br />
                            7C <br />
                            NYC, NY 10016 <br />
                            United States
                        </div>
                    </div>
                </div>

                <form className='ContactUs-right' onSubmit={handleSubmit(onSubmit)}>
                    <div className='d-flex flex-column gap-16'>
                        <div className='form-group'>
                            <label>First Name</label>
                            <input type='text' {...register('firstName')} />
                            {errors.firstName && (
                                <span className='error text-danger'>{errors.firstName.message}</span>
                            )}
                        </div>

                        <div className='form-group'>
                            <label>Last Name</label>
                            <input type='text' {...register('lastName')} />
                            {errors.lastName && (
                                <span className='error text-danger'>{errors.lastName.message}</span>
                            )}
                        </div>

                        <div className='form-group'>
                            <label>Email</label>
                            <input type='email' {...register('email')} />
                            {errors.email && (
                                <span className='error text-danger'>{errors.email.message}</span>
                            )}
                        </div>

                        <div className='form-group'>
                            <label>Organization</label>
                            <input type='text' {...register('organization')} />
                            {errors.organization && (
                                <span className='error text-danger'>{errors.organization.message}</span>
                            )}
                        </div>

                        <div className='form-group'>
                            <label>Message</label>
                            <textarea
                                {...register('message')}
                                style={{ height: '100px' }}
                            />
                            {errors.message && (
                                <span className='error text-danger'>{errors.message.message}</span>
                            )}
                        </div>
                    </div>

                    <div className='d-flex gap-24 justify-content-end Contact_btn_container'>
                        <button
                            type='button'
                            className='menu-outline-btn-theme'
                            onClick={() => { reset(); closeDialog(); }}
                        >
                            Discard
                        </button>

                        <button
                            type='submit'
                            className='menu-btn-theme'
                            disabled={isSubmitting}
                        >
                            <img src={send} alt='send' />
                            {isSubmitting ? 'Sending...' : 'Send'}
                        </button>
                    </div>
                </form>
            </div>
        </div>

    )
}

export default ContactUs
